import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IdentityStore, IdentityStoreType } from '@appState';
import { NotificationsService } from 'cui-components';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { partnerNotFoundByMpnId } from '../app-pages/csp/util';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private identityStore: IdentityStoreType = inject(IdentityStore);
  private notificationsService: NotificationsService = inject(NotificationsService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (request.headers.has('x-skip-interceptor')) {
          throw error;
        }

        if (error instanceof HttpErrorResponse) {
          if (error.status === 401 && error.error.errorCode !== '401-999') {
            // 401-999 means that refresh token failed and this step needs to be skipped.
            this.identityStore.login();
            return of();
          }
        }

        if (Object.entries(error).length) {
          if (!partnerNotFoundByMpnId(error)) {
            this.notificationsService.showNotification(
              `Status: ${error.status}. Message: ${error?.error?.errorMessage ?? error?.error?.message ?? 'Unknown.'}`,
            );
          }
          throw error;
        } else {
          return of();
        }
      }),
    );
  }
}
